import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import breakpoints from 'utils/consts/breakpoints'

import Whatsapp from './Icons/Whatsapp'
import Youtube from './Icons/Youtube'
import Facebook from './Icons/Facebook'
import Linkedin from './Icons/Linkedin'

const Wrapper = styled.div`
  background: var(--color-sns-90);
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 1168px;
  width: 100%;
  margin: 32px auto;
  padding: 0 24px;
  box-sizing: border-box;
`

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 36px;
  flex-wrap: wrap;

  @media screen and (max-width: 1120px) {
    justify-content: center;
    column-gap: 32px;
    row-gap: 8px;
  }
`

const Link = styled.a`
  text-decoration: none;
  color: var(--color-white);
  font: var(--typography-13-16-semibold);
`

const Info = styled.div`
  color: var(--color-white);
  font: var(--typography-12-16-regular);
  margin-bottom: 4px;

  :last-child {
    margin-bottom: 0;
  }
`

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and ${breakpoints.device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 16px;
  }
`

const List = styled.div`
  display: flex;
  flex-direction: column;
`

const SocialNets = styled.div`
  display: flex;
  column-gap: 4px;
`

const systemLangs = ['en', 'fr', 'es', 'it', 'de']

const Footer = () => {
  const { t, i18n } = useTranslation()
  const locale = i18n.language
  const lang = systemLangs.includes(locale) ? locale : 'en'

  return (
    <Wrapper data-testid='wine-public-footer'>
      <Content>
        <Top>
          <Link
            data-testid='wine-public-footer-terms'
            href={`https://worldwinelist.com/${lang}/terms-and-conditions`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('homepage.footer.terms')}
          </Link>
          <Link
            data-testid='wine-public-footer-privacy'
            href={`https://worldwinelist.com/${lang}/privacy-policy`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('homepage.footer.privacy')}
          </Link>
          <Link
            data-testid='wine-public-footer-cookie'
            href={`https://worldwinelist.com/${lang}/cookie-policy`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('homepage.footer.cookie')}
          </Link>
          <Link
            data-testid='wine-public-footer-email'
            href='mailto:contact@worldwinelist.com'
          >
            contact@worldwinelist.com
          </Link>
          <Link href='tel:+41435089206'>+41 43 508 92 06</Link>
          <Link href='tel:+33484800315'>+33 4 84 80 03 15</Link>
          <Link href='tel:+34932205973'>+34 932 20 59 73</Link>
        </Top>
        <Bottom>
          <List>
            <Info>UID: CHE-357.166.792</Info>
            <Info>Legal name: Norpexal Supply Chain Participations GmbH</Info>
            <Info>
              Legal address: Turmstrasse 28, 6312, Steinhausen ZG, Switzerland
            </Info>
            <Info>World Wine List&reg;</Info>
          </List>
          <SocialNets data-testid='wine-public-footer-social'>
            <Link
              data-testid='wine-public-footer-whatsapp'
              href='https://wa.me/33413680416'
              target='_blank'
              rel='noopener noreferrer'
            >
              <Whatsapp />
            </Link>
            <Link
              data-testid='wine-public-footer-youtube'
              href='https://youtube.com/@worldwinelist'
              target='_blank'
              rel='noopener noreferrer'
            >
              <Youtube />
            </Link>
            <Link
              data-testid='wine-public-footer-facebook'
              href='https://www.facebook.com/WorldWineList/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <Facebook />
            </Link>
            <Link
              data-testid='wine-public-footer-linkedin'
              href='https://www.linkedin.com/company/world-wine-list-wwl-platform/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <Linkedin />
            </Link>
          </SocialNets>
        </Bottom>
      </Content>
    </Wrapper>
  )
}

export default Footer
